import React from 'react'

export default function Presentation() {
    return (
        <section className="module bg-dark-60 backimg6">
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="video-box">
                            <div className="video-title font-alt">Build the one you want</div>
                            <div className="video-subtitle font-alt">Our AI car configurator allows you to build and modify your car</div>
                            <a href='#'>
                                <button
                                    className="btn btn-border-w btn-circle mt-30">Go To Workspace</button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}
